const LOGIN_ERROR_KEY = {
    unauthorized: 'unauthorized',
    access_denied: 'access_denied',
    no_valid_membership: 'no_valid_membership',
    unauthorized_person: 'unauthorized_person',
    missing_params: 'missing_params',
    decrypt_state_failed: 'decrypt_state_failed',
    coopId_missing: 'coopId_missing',
    get_token_failed: 'get_token_failed',
    decode_token_failed: 'decode_token_failed',
    callback_failed: 'callback_failed',
    token_verification_failed: 'token_verification_failed',
} as const;

export type LoginErrorValue = (typeof LOGIN_ERROR_KEY)[keyof typeof LOGIN_ERROR_KEY];

export { LOGIN_ERROR_KEY };
